import { Fragment, useEffect, useRef, useState } from 'react'

import { useStep } from '@/hooks/useStep'
import { useStepper } from '@/hooks/useStepper'
import i18n from '@/locale/i18n'
import { CONSULTATION_LANDING_STEP } from '@/types/consultation'
import { STEP_TYPE } from '@/types/step'

const MIN_KEYBOARD_HEIGHT = 300

export const Stepper = () => {
  const { currentStepNumber, steps } = useStepper()
  const { currentStep } = useStep()
  const [isKeyboardOpen, setIsKeyboardOpen] = useState(false)
  const windowHeight = useRef(window.screen.height)

  const onResize = () => {
    setIsKeyboardOpen((window.visualViewport?.height || 0) < windowHeight.current - MIN_KEYBOARD_HEIGHT)
  }

  useEffect(() => {
    window.addEventListener('resize', onResize)

    return () => {
      window.removeEventListener('resize', onResize)
    }
  }, [])

  if (!steps?.length || isKeyboardOpen) return null

  const stepsAmount = steps.length

  return (
    <div data-testid="stepper-container" className={'flex flex-col gap-2 py-2'}>
      <div className="flex items-center justify-between gap-4 px-4">
        {[...Array(stepsAmount)].map((_, index) => {
          const classes = currentStepNumber === index + 1 ? 'bg-white text-primary font-extrabold text-2xl h-11' : 'text-white text-xs h-6'

          return (
            <Fragment key={steps[index].title}>
              <div className="flex aspect-square w-11 flex-col items-center justify-center gap-2" data-testid={`stepper-step-${index + 1}`}>
                <div className={`flex aspect-square items-center justify-center rounded-full border border-white transition-all ${classes}`}>
                  {index + 1}
                </div>
              </div>

              {index < stepsAmount - 1 && <div className="h-[1px] flex-1 bg-white" />}
            </Fragment>
          )
        })}
      </div>

      {currentStep?.type === STEP_TYPE.CONSULTATION && currentStep?.id === CONSULTATION_LANDING_STEP.id && (
        <div className="flex items-center justify-between gap-4 ">
          {[...Array(stepsAmount)].map((_, index) => (
            <label
              key={steps[index].title}
              className={`w-20 text-center text-sm text-white transition-opacity ${currentStepNumber === index + 1 ? '' : 'opacity-70'}`}
              data-testid={`stepper-step-label-${index + 1}`}
            >
              {i18n.t(steps[index].title)}
            </label>
          ))}
        </div>
      )}
    </div>
  )
}
